import { render, staticRenderFns } from "./myaccomodations.vue?vue&type=template&id=52500972&scoped=true&"
import script from "./myaccomodations.vue?vue&type=script&lang=js&"
export * from "./myaccomodations.vue?vue&type=script&lang=js&"
import style1 from "./myaccomodations.vue?vue&type=style&index=1&id=52500972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52500972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52500972')) {
      api.createRecord('52500972', component.options)
    } else {
      api.reload('52500972', component.options)
    }
    module.hot.accept("./myaccomodations.vue?vue&type=template&id=52500972&scoped=true&", function () {
      api.rerender('52500972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accomodation/myaccomodations.vue"
export default component.exports